<template>
    <section :class="{ 'pt-0': mode === 'products' }">
        <Kings v-if="mode === 'products'">
            <template v-slot:title>
                <h3 class="text-capitalize white-light">{{ webdata('algemeen.1.naam', true)}}</h3>
            </template>
            <template v-slot:text>
                <div class="white-light" v-html="webdata('algemeen.1.tekst', true)"></div>
            </template>
            <template v-slot:extra>
            </template>
        </Kings>

        <Filters v-if="mode === 'products'" @filter="onFilter"></Filters>

        <Items
            :loading="loadingProducts"
            :mode="mode"
            :view="view"
            :cart-map="cartMap"
            :related="recommendedProducts"
            @view="onChangeView"
            name="products"
            @loadMore="loadMore"
            :is-paginated="mode === 'products'"
            :showCartForGuests="showCartForGuests"
            >
        </Items>
        <template v-if="Object.keys(cartMap).length > 0 && (showCartForGuests || $store.getters['Auth/isAuthenticated'])">
            <router-link v-if="mode === 'products'" tag="div" :to="{ name: 'products', params: { mode: 'cart' }}" class="c products__cartinfo -is-fixed boxshadow flex -wrap">
                <h3>{{ $t('products.cart') }}</h3>
                <div class="-flex-grow primary-lighter">
                    {{ $tc('products.products', cartQty.amount) }}
                </div>
                <div v-if="$store.getters['Auth/isAuthenticated']">
                    {{ cartQty.price | priceformat }}
                </div>
                <button type="button" class="button">
                    <template v-if="$store.getters['Auth/isAuthenticated']">{{ $t('products.cart') }} </template>
                    <template v-else>{{ $t('products.request_quote') }} </template>
                    <span class="fa">&#xf07a;</span>
                </button>
            </router-link>
        </template>

        <transition name="fade">
            <router-view />
        </transition>
    </section>
</template>

<script>
import Filters from '@/views/products/Filters.vue';
import Items from '@/views/products/Items.vue';
import Kings from '@/views/home/Kings.vue';

export default {
    name: 'Products',
    components: { Filters, Items, Kings },
    props: {
        mode: {
            type: String,
            default: 'products',
        },
        id: Number,
    },
    data() {
        return {
            loadingProducts: false,
            view: 'list',
            recommendedProducts: [],
            showCartForGuests: false,
        };
    },
    mounted() {
        this.getItems()
            .then(() => {
                this.getRelated();
            });
    },
    methods: {
        onChangeView(view) {
            this.view = view;
        },

        onFilter(filters) {
            this.$store.commit('Products/resetPagination');
            const filt = { ...filters };
            filt.size = filt.size.join(',');
            this.getItems({ filters });
        },

        getItems({ filters } = {}) {
            return new Promise((resolve, reject) => {
                this.loadingProducts = true;
                this.$store.dispatch('Products/get', { filters })
                    .then(() => { resolve(); })
                    .catch((err) => { console.log(err); reject(); })
                    .finally(() => { this.loadingProducts = false; });
            });
        },

        getRelated() {
            this.$store.dispatch('Products/get', { filters: { categories: [14] }, return_only: true })
                .then((r) => { this.recommendedProducts = r; })
                .catch((err) => { console.log(err); });
        },

        loadMore() {
            this.loadingProducts = true;
            this.$store.dispatch('Products/loadMore').finally(() => {
                this.loadingProducts = false;
            });
        },
    },
    computed: {
        cartMap() {
            const cartItems = this.$store.getters['Products/cart'];
            const cartMap = {};
            cartItems.forEach((item) => {
                cartMap[`item_${item.product.id}`] = { amount: +item.amount };
            });
            return cartMap;
        },

        cartQty() {
            return this.$store.getters['Products/cartQty'];
        },
    },
};
</script>
